import { ROBOT_SUPPLIER as ROBOT_SUPPLIER_FIELD } from ".";
import { ALL } from "../strings";
import { ROBOTS_PLAN_TYPE } from "../planTypes";

const DEFAULT_VALUE = {
  value: "0",
  label: ALL,
  functionParameters: { value: "0", label: ALL },
};

export const ROBOT_SUPPLIER = {
  title: "Robot Supplier",
  field: ROBOT_SUPPLIER_FIELD,
  mapToValues: (robotSuppliers) =>
    (robotSuppliers || []).reduce(
      (acc, { robotSupplierCode, robotSupplierName }) => {
        const value = {
          value: `${robotSupplierCode}`,
          label: robotSupplierName,
        };
        acc.push({
          ...value,
          functionParameters: value,
        });
        return acc;
      },
      []
    ),
  defaultValue: DEFAULT_VALUE,
  filterCallback: ({ driver, value }) =>
    `${driver?.robotSupplierCode}` === value,
  volumeOverlayRequired: false,
  planTypeRequired: ROBOTS_PLAN_TYPE,
};
